/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'

// Create Virtual Routes

const AdminLazyImport = createFileRoute('/admin')()
const IndexLazyImport = createFileRoute('/')()
const LoginIndexLazyImport = createFileRoute('/login/')()
const AdminIndexLazyImport = createFileRoute('/admin/')()
const AdminSupportLazyImport = createFileRoute('/admin/support')()
const AdminSuperUserLazyImport = createFileRoute('/admin/super-user')()
const AdminSmartrrAccountLazyImport = createFileRoute(
  '/admin/smartrr-account',
)()
const AdminSetupLazyImport = createFileRoute('/admin/setup')()
const AdminOrdersLazyImport = createFileRoute('/admin/orders')()
const AdminLoyaltyLazyImport = createFileRoute('/admin/loyalty')()
const AdminHomeLazyImport = createFileRoute('/admin/home')()
const AdminBillsLazyImport = createFileRoute('/admin/bills')()
const AdminAnalyticsLazyImport = createFileRoute('/admin/analytics')()
const AdminAdvancedAnalyticsLazyImport = createFileRoute(
  '/admin/advanced-analytics',
)()
const AdminSubscriptionsIndexLazyImport = createFileRoute(
  '/admin/subscriptions/',
)()
const AdminCustomersIndexLazyImport = createFileRoute('/admin/customers/')()
const AdminSubscriptionsCreatenewLazyImport = createFileRoute(
  '/admin/subscriptions/createnew',
)()
const AdminSubscriptionsCreateLazyImport = createFileRoute(
  '/admin/subscriptions/create',
)()
const AdminSubscriptionsSubscriptionIdLazyImport = createFileRoute(
  '/admin/subscriptions/$subscriptionId',
)()
const AdminCustomersCustomerIdLazyImport = createFileRoute(
  '/admin/customers/$customerId',
)()
const AdminConfigureTranslationsLazyImport = createFileRoute(
  '/admin/configure/translations',
)()
const AdminConfigureThemingLazyImport = createFileRoute(
  '/admin/configure/theming',
)()
const AdminConfigureSubscriberEngagementLazyImport = createFileRoute(
  '/admin/configure/subscriber-engagement',
)()
const AdminConfigureMigrationsLazyImport = createFileRoute(
  '/admin/configure/migrations',
)()
const AdminConfigureIntegrationsLazyImport = createFileRoute(
  '/admin/configure/integrations',
)()
const AdminConfigureDiscountsLazyImport = createFileRoute(
  '/admin/configure/discounts',
)()
const AdminConfigureChurnPreventionLazyImport = createFileRoute(
  '/admin/configure/churn-prevention',
)()
const AdminConfigureBillingSettingsLazyImport = createFileRoute(
  '/admin/configure/billing-settings',
)()
const AdminConfigurePlansIndexLazyImport = createFileRoute(
  '/admin/configure/plans/',
)()
const AdminConfigureDeliveryProfilesIndexLazyImport = createFileRoute(
  '/admin/configure/delivery-profiles/',
)()
const AdminConfigureBundlesIndexLazyImport = createFileRoute(
  '/admin/configure/bundles/',
)()
const AdminConfigurePlansPlanIdLazyImport = createFileRoute(
  '/admin/configure/plans/$planId',
)()
const AdminConfigureDeliveryProfilesDeliveryProfileIdLazyImport =
  createFileRoute('/admin/configure/delivery-profiles/$deliveryProfileId')()
const AdminConfigureBundlesBundleIdLazyImport = createFileRoute(
  '/admin/configure/bundles/$bundleId',
)()

// Create/Update Routes

const AdminLazyRoute = AdminLazyImport.update({
  path: '/admin',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/admin.lazy').then((d) => d.Route))

const IndexLazyRoute = IndexLazyImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

const LoginIndexLazyRoute = LoginIndexLazyImport.update({
  path: '/login/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/login/index.lazy').then((d) => d.Route))

const AdminIndexLazyRoute = AdminIndexLazyImport.update({
  path: '/',
  getParentRoute: () => AdminLazyRoute,
} as any).lazy(() => import('./routes/admin/index.lazy').then((d) => d.Route))

const AdminSupportLazyRoute = AdminSupportLazyImport.update({
  path: '/support',
  getParentRoute: () => AdminLazyRoute,
} as any).lazy(() => import('./routes/admin/support.lazy').then((d) => d.Route))

const AdminSuperUserLazyRoute = AdminSuperUserLazyImport.update({
  path: '/super-user',
  getParentRoute: () => AdminLazyRoute,
} as any).lazy(() =>
  import('./routes/admin/super-user.lazy').then((d) => d.Route),
)

const AdminSmartrrAccountLazyRoute = AdminSmartrrAccountLazyImport.update({
  path: '/smartrr-account',
  getParentRoute: () => AdminLazyRoute,
} as any).lazy(() =>
  import('./routes/admin/smartrr-account.lazy').then((d) => d.Route),
)

const AdminSetupLazyRoute = AdminSetupLazyImport.update({
  path: '/setup',
  getParentRoute: () => AdminLazyRoute,
} as any).lazy(() => import('./routes/admin/setup.lazy').then((d) => d.Route))

const AdminOrdersLazyRoute = AdminOrdersLazyImport.update({
  path: '/orders',
  getParentRoute: () => AdminLazyRoute,
} as any).lazy(() => import('./routes/admin/orders.lazy').then((d) => d.Route))

const AdminLoyaltyLazyRoute = AdminLoyaltyLazyImport.update({
  path: '/loyalty',
  getParentRoute: () => AdminLazyRoute,
} as any).lazy(() => import('./routes/admin/loyalty.lazy').then((d) => d.Route))

const AdminHomeLazyRoute = AdminHomeLazyImport.update({
  path: '/home',
  getParentRoute: () => AdminLazyRoute,
} as any).lazy(() => import('./routes/admin/home.lazy').then((d) => d.Route))

const AdminBillsLazyRoute = AdminBillsLazyImport.update({
  path: '/bills',
  getParentRoute: () => AdminLazyRoute,
} as any).lazy(() => import('./routes/admin/bills.lazy').then((d) => d.Route))

const AdminAnalyticsLazyRoute = AdminAnalyticsLazyImport.update({
  path: '/analytics',
  getParentRoute: () => AdminLazyRoute,
} as any).lazy(() =>
  import('./routes/admin/analytics.lazy').then((d) => d.Route),
)

const AdminAdvancedAnalyticsLazyRoute = AdminAdvancedAnalyticsLazyImport.update(
  {
    path: '/advanced-analytics',
    getParentRoute: () => AdminLazyRoute,
  } as any,
).lazy(() =>
  import('./routes/admin/advanced-analytics.lazy').then((d) => d.Route),
)

const AdminSubscriptionsIndexLazyRoute =
  AdminSubscriptionsIndexLazyImport.update({
    path: '/subscriptions/',
    getParentRoute: () => AdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/subscriptions.index.lazy').then((d) => d.Route),
  )

const AdminCustomersIndexLazyRoute = AdminCustomersIndexLazyImport.update({
  path: '/customers/',
  getParentRoute: () => AdminLazyRoute,
} as any).lazy(() =>
  import('./routes/admin/customers.index.lazy').then((d) => d.Route),
)

const AdminSubscriptionsCreatenewLazyRoute =
  AdminSubscriptionsCreatenewLazyImport.update({
    path: '/subscriptions/createnew',
    getParentRoute: () => AdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/subscriptions.createnew.lazy').then((d) => d.Route),
  )

const AdminSubscriptionsCreateLazyRoute =
  AdminSubscriptionsCreateLazyImport.update({
    path: '/subscriptions/create',
    getParentRoute: () => AdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/subscriptions.create.lazy').then((d) => d.Route),
  )

const AdminSubscriptionsSubscriptionIdLazyRoute =
  AdminSubscriptionsSubscriptionIdLazyImport.update({
    path: '/subscriptions/$subscriptionId',
    getParentRoute: () => AdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/subscriptions.$subscriptionId.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminCustomersCustomerIdLazyRoute =
  AdminCustomersCustomerIdLazyImport.update({
    path: '/customers/$customerId',
    getParentRoute: () => AdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/customers.$customerId.lazy').then((d) => d.Route),
  )

const AdminConfigureTranslationsLazyRoute =
  AdminConfigureTranslationsLazyImport.update({
    path: '/configure/translations',
    getParentRoute: () => AdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/configure.translations.lazy').then((d) => d.Route),
  )

const AdminConfigureThemingLazyRoute = AdminConfigureThemingLazyImport.update({
  path: '/configure/theming',
  getParentRoute: () => AdminLazyRoute,
} as any).lazy(() =>
  import('./routes/admin/configure.theming.lazy').then((d) => d.Route),
)

const AdminConfigureSubscriberEngagementLazyRoute =
  AdminConfigureSubscriberEngagementLazyImport.update({
    path: '/configure/subscriber-engagement',
    getParentRoute: () => AdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/configure.subscriber-engagement.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminConfigureMigrationsLazyRoute =
  AdminConfigureMigrationsLazyImport.update({
    path: '/configure/migrations',
    getParentRoute: () => AdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/configure.migrations.lazy').then((d) => d.Route),
  )

const AdminConfigureIntegrationsLazyRoute =
  AdminConfigureIntegrationsLazyImport.update({
    path: '/configure/integrations',
    getParentRoute: () => AdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/configure.integrations.lazy').then((d) => d.Route),
  )

const AdminConfigureDiscountsLazyRoute =
  AdminConfigureDiscountsLazyImport.update({
    path: '/configure/discounts',
    getParentRoute: () => AdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/configure.discounts.lazy').then((d) => d.Route),
  )

const AdminConfigureChurnPreventionLazyRoute =
  AdminConfigureChurnPreventionLazyImport.update({
    path: '/configure/churn-prevention',
    getParentRoute: () => AdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/configure.churn-prevention.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminConfigureBillingSettingsLazyRoute =
  AdminConfigureBillingSettingsLazyImport.update({
    path: '/configure/billing-settings',
    getParentRoute: () => AdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/configure.billing-settings.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminConfigurePlansIndexLazyRoute =
  AdminConfigurePlansIndexLazyImport.update({
    path: '/configure/plans/',
    getParentRoute: () => AdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/configure.plans.index.lazy').then((d) => d.Route),
  )

const AdminConfigureDeliveryProfilesIndexLazyRoute =
  AdminConfigureDeliveryProfilesIndexLazyImport.update({
    path: '/configure/delivery-profiles/',
    getParentRoute: () => AdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/configure.delivery-profiles.index.lazy').then(
      (d) => d.Route,
    ),
  )

const AdminConfigureBundlesIndexLazyRoute =
  AdminConfigureBundlesIndexLazyImport.update({
    path: '/configure/bundles/',
    getParentRoute: () => AdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/configure.bundles.index.lazy').then((d) => d.Route),
  )

const AdminConfigurePlansPlanIdLazyRoute =
  AdminConfigurePlansPlanIdLazyImport.update({
    path: '/configure/plans/$planId',
    getParentRoute: () => AdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/configure.plans.$planId.lazy').then((d) => d.Route),
  )

const AdminConfigureDeliveryProfilesDeliveryProfileIdLazyRoute =
  AdminConfigureDeliveryProfilesDeliveryProfileIdLazyImport.update({
    path: '/configure/delivery-profiles/$deliveryProfileId',
    getParentRoute: () => AdminLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/admin/configure.delivery-profiles.$deliveryProfileId.lazy'
    ).then((d) => d.Route),
  )

const AdminConfigureBundlesBundleIdLazyRoute =
  AdminConfigureBundlesBundleIdLazyImport.update({
    path: '/configure/bundles/$bundleId',
    getParentRoute: () => AdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/admin/configure.bundles.$bundleId.lazy').then(
      (d) => d.Route,
    ),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminLazyImport
      parentRoute: typeof rootRoute
    }
    '/admin/advanced-analytics': {
      id: '/admin/advanced-analytics'
      path: '/advanced-analytics'
      fullPath: '/admin/advanced-analytics'
      preLoaderRoute: typeof AdminAdvancedAnalyticsLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/bills': {
      id: '/admin/bills'
      path: '/bills'
      fullPath: '/admin/bills'
      preLoaderRoute: typeof AdminBillsLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/home': {
      id: '/admin/home'
      path: '/home'
      fullPath: '/admin/home'
      preLoaderRoute: typeof AdminHomeLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/loyalty': {
      id: '/admin/loyalty'
      path: '/loyalty'
      fullPath: '/admin/loyalty'
      preLoaderRoute: typeof AdminLoyaltyLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/orders': {
      id: '/admin/orders'
      path: '/orders'
      fullPath: '/admin/orders'
      preLoaderRoute: typeof AdminOrdersLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/setup': {
      id: '/admin/setup'
      path: '/setup'
      fullPath: '/admin/setup'
      preLoaderRoute: typeof AdminSetupLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/smartrr-account': {
      id: '/admin/smartrr-account'
      path: '/smartrr-account'
      fullPath: '/admin/smartrr-account'
      preLoaderRoute: typeof AdminSmartrrAccountLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/super-user': {
      id: '/admin/super-user'
      path: '/super-user'
      fullPath: '/admin/super-user'
      preLoaderRoute: typeof AdminSuperUserLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/support': {
      id: '/admin/support'
      path: '/support'
      fullPath: '/admin/support'
      preLoaderRoute: typeof AdminSupportLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/admin/configure/billing-settings': {
      id: '/admin/configure/billing-settings'
      path: '/configure/billing-settings'
      fullPath: '/admin/configure/billing-settings'
      preLoaderRoute: typeof AdminConfigureBillingSettingsLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/configure/churn-prevention': {
      id: '/admin/configure/churn-prevention'
      path: '/configure/churn-prevention'
      fullPath: '/admin/configure/churn-prevention'
      preLoaderRoute: typeof AdminConfigureChurnPreventionLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/configure/discounts': {
      id: '/admin/configure/discounts'
      path: '/configure/discounts'
      fullPath: '/admin/configure/discounts'
      preLoaderRoute: typeof AdminConfigureDiscountsLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/configure/integrations': {
      id: '/admin/configure/integrations'
      path: '/configure/integrations'
      fullPath: '/admin/configure/integrations'
      preLoaderRoute: typeof AdminConfigureIntegrationsLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/configure/migrations': {
      id: '/admin/configure/migrations'
      path: '/configure/migrations'
      fullPath: '/admin/configure/migrations'
      preLoaderRoute: typeof AdminConfigureMigrationsLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/configure/subscriber-engagement': {
      id: '/admin/configure/subscriber-engagement'
      path: '/configure/subscriber-engagement'
      fullPath: '/admin/configure/subscriber-engagement'
      preLoaderRoute: typeof AdminConfigureSubscriberEngagementLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/configure/theming': {
      id: '/admin/configure/theming'
      path: '/configure/theming'
      fullPath: '/admin/configure/theming'
      preLoaderRoute: typeof AdminConfigureThemingLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/configure/translations': {
      id: '/admin/configure/translations'
      path: '/configure/translations'
      fullPath: '/admin/configure/translations'
      preLoaderRoute: typeof AdminConfigureTranslationsLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/customers/$customerId': {
      id: '/admin/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/admin/customers/$customerId'
      preLoaderRoute: typeof AdminCustomersCustomerIdLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/subscriptions/$subscriptionId': {
      id: '/admin/subscriptions/$subscriptionId'
      path: '/subscriptions/$subscriptionId'
      fullPath: '/admin/subscriptions/$subscriptionId'
      preLoaderRoute: typeof AdminSubscriptionsSubscriptionIdLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/subscriptions/create': {
      id: '/admin/subscriptions/create'
      path: '/subscriptions/create'
      fullPath: '/admin/subscriptions/create'
      preLoaderRoute: typeof AdminSubscriptionsCreateLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/subscriptions/createnew': {
      id: '/admin/subscriptions/createnew'
      path: '/subscriptions/createnew'
      fullPath: '/admin/subscriptions/createnew'
      preLoaderRoute: typeof AdminSubscriptionsCreatenewLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/customers/': {
      id: '/admin/customers/'
      path: '/customers'
      fullPath: '/admin/customers'
      preLoaderRoute: typeof AdminCustomersIndexLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/subscriptions/': {
      id: '/admin/subscriptions/'
      path: '/subscriptions'
      fullPath: '/admin/subscriptions'
      preLoaderRoute: typeof AdminSubscriptionsIndexLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/configure/bundles/$bundleId': {
      id: '/admin/configure/bundles/$bundleId'
      path: '/configure/bundles/$bundleId'
      fullPath: '/admin/configure/bundles/$bundleId'
      preLoaderRoute: typeof AdminConfigureBundlesBundleIdLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/configure/delivery-profiles/$deliveryProfileId': {
      id: '/admin/configure/delivery-profiles/$deliveryProfileId'
      path: '/configure/delivery-profiles/$deliveryProfileId'
      fullPath: '/admin/configure/delivery-profiles/$deliveryProfileId'
      preLoaderRoute: typeof AdminConfigureDeliveryProfilesDeliveryProfileIdLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/configure/plans/$planId': {
      id: '/admin/configure/plans/$planId'
      path: '/configure/plans/$planId'
      fullPath: '/admin/configure/plans/$planId'
      preLoaderRoute: typeof AdminConfigurePlansPlanIdLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/configure/bundles/': {
      id: '/admin/configure/bundles/'
      path: '/configure/bundles'
      fullPath: '/admin/configure/bundles'
      preLoaderRoute: typeof AdminConfigureBundlesIndexLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/configure/delivery-profiles/': {
      id: '/admin/configure/delivery-profiles/'
      path: '/configure/delivery-profiles'
      fullPath: '/admin/configure/delivery-profiles'
      preLoaderRoute: typeof AdminConfigureDeliveryProfilesIndexLazyImport
      parentRoute: typeof AdminLazyImport
    }
    '/admin/configure/plans/': {
      id: '/admin/configure/plans/'
      path: '/configure/plans'
      fullPath: '/admin/configure/plans'
      preLoaderRoute: typeof AdminConfigurePlansIndexLazyImport
      parentRoute: typeof AdminLazyImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexLazyRoute,
  AdminLazyRoute: AdminLazyRoute.addChildren({
    AdminAdvancedAnalyticsLazyRoute,
    AdminAnalyticsLazyRoute,
    AdminBillsLazyRoute,
    AdminHomeLazyRoute,
    AdminLoyaltyLazyRoute,
    AdminOrdersLazyRoute,
    AdminSetupLazyRoute,
    AdminSmartrrAccountLazyRoute,
    AdminSuperUserLazyRoute,
    AdminSupportLazyRoute,
    AdminIndexLazyRoute,
    AdminConfigureBillingSettingsLazyRoute,
    AdminConfigureChurnPreventionLazyRoute,
    AdminConfigureDiscountsLazyRoute,
    AdminConfigureIntegrationsLazyRoute,
    AdminConfigureMigrationsLazyRoute,
    AdminConfigureSubscriberEngagementLazyRoute,
    AdminConfigureThemingLazyRoute,
    AdminConfigureTranslationsLazyRoute,
    AdminCustomersCustomerIdLazyRoute,
    AdminSubscriptionsSubscriptionIdLazyRoute,
    AdminSubscriptionsCreateLazyRoute,
    AdminSubscriptionsCreatenewLazyRoute,
    AdminCustomersIndexLazyRoute,
    AdminSubscriptionsIndexLazyRoute,
    AdminConfigureBundlesBundleIdLazyRoute,
    AdminConfigureDeliveryProfilesDeliveryProfileIdLazyRoute,
    AdminConfigurePlansPlanIdLazyRoute,
    AdminConfigureBundlesIndexLazyRoute,
    AdminConfigureDeliveryProfilesIndexLazyRoute,
    AdminConfigurePlansIndexLazyRoute,
  }),
  LoginIndexLazyRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/admin",
        "/login/"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/admin": {
      "filePath": "admin.lazy.tsx",
      "children": [
        "/admin/advanced-analytics",
        "/admin/analytics",
        "/admin/bills",
        "/admin/home",
        "/admin/loyalty",
        "/admin/orders",
        "/admin/setup",
        "/admin/smartrr-account",
        "/admin/super-user",
        "/admin/support",
        "/admin/",
        "/admin/configure/billing-settings",
        "/admin/configure/churn-prevention",
        "/admin/configure/discounts",
        "/admin/configure/integrations",
        "/admin/configure/migrations",
        "/admin/configure/subscriber-engagement",
        "/admin/configure/theming",
        "/admin/configure/translations",
        "/admin/customers/$customerId",
        "/admin/subscriptions/$subscriptionId",
        "/admin/subscriptions/create",
        "/admin/subscriptions/createnew",
        "/admin/customers/",
        "/admin/subscriptions/",
        "/admin/configure/bundles/$bundleId",
        "/admin/configure/delivery-profiles/$deliveryProfileId",
        "/admin/configure/plans/$planId",
        "/admin/configure/bundles/",
        "/admin/configure/delivery-profiles/",
        "/admin/configure/plans/"
      ]
    },
    "/admin/advanced-analytics": {
      "filePath": "admin/advanced-analytics.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/analytics": {
      "filePath": "admin/analytics.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/bills": {
      "filePath": "admin/bills.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/home": {
      "filePath": "admin/home.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/loyalty": {
      "filePath": "admin/loyalty.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/orders": {
      "filePath": "admin/orders.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/setup": {
      "filePath": "admin/setup.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/smartrr-account": {
      "filePath": "admin/smartrr-account.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/super-user": {
      "filePath": "admin/super-user.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/support": {
      "filePath": "admin/support.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/": {
      "filePath": "admin/index.lazy.tsx",
      "parent": "/admin"
    },
    "/login/": {
      "filePath": "login/index.lazy.tsx"
    },
    "/admin/configure/billing-settings": {
      "filePath": "admin/configure.billing-settings.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/configure/churn-prevention": {
      "filePath": "admin/configure.churn-prevention.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/configure/discounts": {
      "filePath": "admin/configure.discounts.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/configure/integrations": {
      "filePath": "admin/configure.integrations.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/configure/migrations": {
      "filePath": "admin/configure.migrations.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/configure/subscriber-engagement": {
      "filePath": "admin/configure.subscriber-engagement.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/configure/theming": {
      "filePath": "admin/configure.theming.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/configure/translations": {
      "filePath": "admin/configure.translations.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/customers/$customerId": {
      "filePath": "admin/customers.$customerId.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/subscriptions/$subscriptionId": {
      "filePath": "admin/subscriptions.$subscriptionId.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/subscriptions/create": {
      "filePath": "admin/subscriptions.create.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/subscriptions/createnew": {
      "filePath": "admin/subscriptions.createnew.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/customers/": {
      "filePath": "admin/customers.index.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/subscriptions/": {
      "filePath": "admin/subscriptions.index.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/configure/bundles/$bundleId": {
      "filePath": "admin/configure.bundles.$bundleId.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/configure/delivery-profiles/$deliveryProfileId": {
      "filePath": "admin/configure.delivery-profiles.$deliveryProfileId.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/configure/plans/$planId": {
      "filePath": "admin/configure.plans.$planId.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/configure/bundles/": {
      "filePath": "admin/configure.bundles.index.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/configure/delivery-profiles/": {
      "filePath": "admin/configure.delivery-profiles.index.lazy.tsx",
      "parent": "/admin"
    },
    "/admin/configure/plans/": {
      "filePath": "admin/configure.plans.index.lazy.tsx",
      "parent": "/admin"
    }
  }
}
ROUTE_MANIFEST_END */
